import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {LogoWithLabel} from '@shared/components/Logo/LogoWithLabel'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {FooterCompanyLicenseLink} from './FooterCompanyLicenseLink'
import {FooterContacts} from './FooterContacts'
import {FooterContactsExternalLinks} from './FooterContactsExternalLinks'
import {FooterNavigationForAppSections} from './FooterNavigationForAppSections'
import {FooterNavigationForServicePages} from './FooterNavigationForServicePages'

// Нижняя часть страницы со ссылками и копирайтом.
// Макет: десктоп 577:9013.
export function FooterDesktop() {

    return (
        <Card className="footer-desktop">
            <CardBody className="p-6 d-flex flex-column align-items-stretch gap-6">
                <FooterNavigationForAppSections />
                <div className="border-top" />
                <div className="d-flex flex-column align-items-center">
                    <LogoWithLabel
                        url={appUrl().index}
                        alt={trans().common.app_name}
                        height={50}
                    />
                    <HtmlContent
                        html={trans().common.footer.company_info}
                        block
                        className="text-muted mt-4 text-center fs-8"
                        style={{maxWidth: 280}}
                    />
                </div>
                <div className="border-top" />
                <div className="flex-row-between">
                    <FooterContacts />
                    <div className="flex-row-center gap-9">
                        <FooterContactsExternalLinks />
                        <FooterCompanyLicenseLink />
                    </div>
                </div>
                <div className="flex-row-between align-items-start gap-6">
                    <FooterNavigationForServicePages
                        className="d-flex flex-row gap-4 gap-6"
                    />
                    <HtmlContent
                        html={trans().common.footer.copyright}
                        block
                        className="footer-copyright text-muted fs-7 text-end"
                    />
                </div>
            </CardBody>
        </Card>
    )
}
